export default "__VITE_ASSET__CabRD36r__"